import {Theme, createStyles} from '@material-ui/core';

export const languageMenuStyles = (theme: Theme) =>
	createStyles({
		root: {
			marginLeft: theme.spacing(2),
		},
		button: {
			transition: 'color',
			transitionDuration: `${theme.transitions.duration.standard}ms`,
			'&:hover': {
				color: theme.palette.primary.light,
			},
		},
		menu: {
			backgroundColor: theme.palette.primary.dark,
		},
		link: {
			color: theme.palette.common.white,
			transition: 'color',
			transitionDuration: `${theme.transitions.duration.standard}ms`,
		},
	});
